import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { OnlyNumberDirective } from './directives/onlyNumbers.directives';
import { CurrencyPipe } from './pipe/currency.pipe';
import { CurrencyFormatterDirective } from './pipe/currency-formatter.directive';
import { ToastrModule } from 'ngx-toastr';

import { ViewImageComponent } from './component/view-image/view-image.component';
import { UploadDocumentComponent } from './component/upload-document/upload-document.component';

import { ErrorInterceptor } from './helpers/error.interceptor';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { SearchFilterPipe } from './pipe/search-filter.pipe';
import { SearchpassengersPipe } from './pipe/searchpassengers.pipe';
import { DateFilterComponent } from './component/date-filter/date-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    HttpClientModule,
    NgbNavModule,
    ToastrModule.forRoot(), // ToastrModule added
    PerfectScrollbarModule,
  ],
  declarations: [
    OnlyNumberDirective,
    CurrencyPipe,
    CurrencyFormatterDirective,
    ViewImageComponent,
    UploadDocumentComponent,
    SearchFilterPipe,
    SearchpassengersPipe,
    DateFilterComponent
  ],
  providers: [
    SearchFilterPipe,
    SearchpassengersPipe,
    CurrencyPipe,
    CurrencyFormatterDirective,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  exports: [
    FormsModule,
    OnlyNumberDirective,
    CurrencyPipe,
    SearchFilterPipe,
    SearchpassengersPipe,
    CurrencyFormatterDirective,
    NgbModule,
    NgSelectModule,
    HttpClientModule,
    UploadDocumentComponent,
    SearchpassengersPipe,
    DateFilterComponent,
    NgbNavModule
  ]
})
export class SharedModuleGZ { }
